import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/deleteIcon.svg'
import _imports_1 from '@/assets/tooltip.svg'
import _imports_2 from '@/assets/ActionIcon.svg'
import _imports_3 from '@/assets/link.svg'


const _hoisted_1 = { class: "table-data-root" }
const _hoisted_2 = { class: "table-card-inner" }
const _hoisted_3 = { class: "table-container table-container-fit" }
const _hoisted_4 = { class: "table-header-wrap" }
const _hoisted_5 = { class: "table-header-row" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "cursor-pointer" }
const _hoisted_9 = ["onMousedown"]
const _hoisted_10 = {
  key: 0,
  class: "table-filter-row"
}
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = ["value"]
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 4,
  class: "flex justify-center"
}
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["value"]
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 5,
  class: "flex justify-center"
}
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = ["value"]
const _hoisted_30 = ["value"]
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = ["value"]
const _hoisted_33 = ["value"]
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = ["value"]
const _hoisted_36 = ["value"]
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = ["value"]
const _hoisted_39 = ["value"]
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = ["value"]
const _hoisted_42 = ["value"]
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = ["value"]
const _hoisted_45 = ["value"]
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = ["value"]
const _hoisted_48 = ["value"]
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = ["value"]
const _hoisted_51 = ["value"]
const _hoisted_52 = ["onUpdate:modelValue"]
const _hoisted_53 = ["value"]
const _hoisted_54 = ["value"]
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = ["value"]
const _hoisted_57 = ["value"]
const _hoisted_58 = ["onUpdate:modelValue"]
const _hoisted_59 = ["value"]
const _hoisted_60 = ["value"]
const _hoisted_61 = ["onUpdate:modelValue"]
const _hoisted_62 = ["value"]
const _hoisted_63 = ["value"]
const _hoisted_64 = { key: 17 }
const _hoisted_65 = ["onUpdate:modelValue"]
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { class: "table-body-scroll" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_71 = ["colspan"]
const _hoisted_72 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_73 = {
  key: 1,
  class: "emptyFixed"
}
const _hoisted_74 = { class: "cursor-pointer rowHeight" }
const _hoisted_75 = ["colspan"]
const _hoisted_76 = {
  key: 2,
  class: "tbodylast"
}
const _hoisted_77 = ["onClick"]
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { class: "center-content" }
const _hoisted_81 = {
  key: 2,
  class: "flex"
}
const _hoisted_82 = { class: "center-content" }
const _hoisted_83 = { key: 4 }
const _hoisted_84 = { key: 5 }
const _hoisted_85 = { class: "flex justify-center items-center" }
const _hoisted_86 = ["onClick"]
const _hoisted_87 = { key: 6 }
const _hoisted_88 = { class: "table-ellipsis" }
const _hoisted_89 = ["onMousemove"]
const _hoisted_90 = { key: 7 }
const _hoisted_91 = { key: 8 }
const _hoisted_92 = { class: "table-ellipsis" }
const _hoisted_93 = ["onMousemove"]
const _hoisted_94 = { key: 9 }
const _hoisted_95 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_96 = ["onMousemove"]
const _hoisted_97 = { key: 10 }
const _hoisted_98 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_99 = ["onMousemove"]
const _hoisted_100 = ["onMousemove"]
const _hoisted_101 = ["onMousemove"]
const _hoisted_102 = { key: 11 }
const _hoisted_103 = { class: "table-ellipsis" }
const _hoisted_104 = ["onMousemove"]
const _hoisted_105 = { key: 12 }
const _hoisted_106 = { class: "cursor-pointer text-xs" }
const _hoisted_107 = {
  key: 13,
  class: "center-content"
}
const _hoisted_108 = {
  key: 14,
  class: "flex items-center justify-center"
}
const _hoisted_109 = {
  key: 15,
  class: "flex items-center justify-center"
}
const _hoisted_110 = { key: 16 }
const _hoisted_111 = ["onMousemove"]
const _hoisted_112 = ["onMousemove"]
const _hoisted_113 = {
  key: 2,
  class: "flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none"
}
const _hoisted_114 = {
  key: 3,
  class: "flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none cursor-pointer"
}
const _hoisted_115 = {
  key: 17,
  class: "flex justify-center items-center"
}
const _hoisted_116 = {
  key: 18,
  class: "flex justify-center items-center"
}
const _hoisted_117 = { key: 19 }
const _hoisted_118 = ["onMousemove"]
const _hoisted_119 = { key: 20 }
const _hoisted_120 = ["onMousemove"]
const _hoisted_121 = {
  key: 21,
  class: "flex justify-center items-center"
}
const _hoisted_122 = { class: "table-ellipsis" }
const _hoisted_123 = ["onMousemove"]
const _hoisted_124 = {
  key: 22,
  class: "flex justify-center"
}
const _hoisted_125 = {
  key: 23,
  class: ""
}
const _hoisted_126 = {
  key: 24,
  class: "flex items-center justify-center"
}
const _hoisted_127 = ["onMousemove"]
const _hoisted_128 = { key: 25 }
const _hoisted_129 = { class: "relative flex justify-center items-center regular" }
const _hoisted_130 = ["onMousemove"]
const _hoisted_131 = {
  key: 26,
  class: "flex justify-center items-center"
}
const _hoisted_132 = { key: 27 }
const _hoisted_133 = { key: 0 }
const _hoisted_134 = { key: 1 }
const _hoisted_135 = {
  key: 30,
  class: "relative",
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_136 = { key: 31 }
const _hoisted_137 = {
  key: 32,
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_138 = { key: 33 }
const _hoisted_139 = { class: "table-ellipsis" }
const _hoisted_140 = ["onMousemove"]
const _hoisted_141 = {
  key: 0,
  class: "cursor-pointer"
}
const _hoisted_142 = { class: "flex justify-end h-5 ImageResponsive" }
const _hoisted_143 = ["onClick"]
const _hoisted_144 = ["onClick"]
const _hoisted_145 = { class: "flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["bg-white table-card-shell", _ctx.isFrameworksTable ? 'tableCornerRadiusForFramework' : 'tableCornerRadius'])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", {
              class: "table-fit-card table-header-table",
              style: _normalizeStyle(_ctx.tableResizeStyle)
            }, [
              _createElementVNode("colgroup", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
                  return (_openBlock(), _createElementBlock("col", {
                    key: 'h-'+presentColumn,
                    style: _normalizeStyle(_ctx.columnStyle(presentColumn))
                  }, null, 4))
                }), 128))
              ]),
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
                    return (_openBlock(), _createElementBlock("th", {
                      scope: "col",
                      key: presentColumn,
                      class: _normalizeClass([_ctx.getColumnHeadWidth(presentColumn), "bg-white capitalize resizable-th"]),
                      style: _normalizeStyle(_ctx.columnStyle(presentColumn)),
                      onClick: ($event: any) => (_ctx.onHeaderClick(presentColumn))
                    }, [
                      (presentColumn == 'controlscount'||presentColumn == 'no.of controls'||presentColumn =='health'|| presentColumn == 'kpiHealth'|| presentColumn == 'tier'|| presentColumn == 'controlFrequency')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["flex", _ctx.getPaddingForColumn(presentColumn)]),
                            style: {"justify-content":"center"}
                          }, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.getColumnLabel(presentColumn)), 1),
                            (_ctx.getColumnLabel(presentColumn) != '')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == presentColumn ? _ctx.classSort : 'opacity-50'])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ], 2))
                        : (presentColumn == 'publicFacing')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["flex", _ctx.getPaddingForColumn(presentColumn)]),
                              style: {"display":"flex","justify-content":"center"}
                            }, [
                              _createElementVNode("div", null, _toDisplayString(_ctx.getColumnLabel(presentColumn)), 1),
                              (_ctx.getColumnLabel(presentColumn) != '')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["sort cursor-pointer", _ctx.className == presentColumn ? _ctx.classSort : 'opacity-50'])
                                  }, null, 2))
                                : _createCommentVNode("", true)
                            ], 2))
                          : (presentColumn != 'status' && presentColumn != 'severity' && presentColumn != 'KPIs')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["flex", _ctx.getPaddingForColumn(presentColumn)])
                                }, [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.getColumnLabel(presentColumn)), 1),
                                  (_ctx.getColumnLabel(presentColumn) != '')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["sort cursor-pointer", _ctx.className == presentColumn ? _ctx.classSort : 'opacity-50'])
                                      }, null, 2))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ]))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 3,
                                class: _normalizeClass(["flex", presentColumn == 'status' || presentColumn == 'severity' || presentColumn == 'KPIs'? 'justify-center' : ''])
                              }, [
                                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.getColumnLabel(presentColumn)), 1),
                                (_ctx.getColumnLabel(presentColumn) != '')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass(["sort cursor-pointer", _ctx.className == presentColumn ? _ctx.classSort : 'opacity-50'])
                                    }, null, 2))
                                  : _createCommentVNode("", true)
                              ], 2)),
                      _createElementVNode("span", {
                        class: "column-resize-handle",
                        onMousedown: _withModifiers(($event: any) => (_ctx.startColumnResize($event, presentColumn)), ["stop","prevent"])
                      }, null, 40, _hoisted_9)
                    ], 14, _hoisted_6))
                  }), 128))
                ]),
                (_ctx.visibility)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (name, index) => {
                        return (_openBlock(), _createElementBlock("td", {
                          class: _normalizeClass(["bg-white", [name === 'status'|| name == 'health' || name == 'kpiHealth' || name== 'tier'|| name == 'controlFrequency' ? 'text-center' : '',_ctx.getFilterStyles(name)]]),
                          key: index,
                          style: _normalizeStyle(_ctx.columnStyle(name))
                        }, [
                          (name == 'priority')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 0,
                                class: _normalizeClass(["priorityStyles m-auto", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                              }, [
                                _createElementVNode("option", {
                                  value: _ctx.filters.name,
                                  selected: "",
                                  disabled: "",
                                  hidden: ""
                                }, "Select", 8, _hoisted_12),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbPriority, (value, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    class: "optionColors",
                                    key: index,
                                    value: value.value
                                  }, _toDisplayString(value.key), 9, _hoisted_13))
                                }), 128))
                              ], 10, _hoisted_11)), [
                                [_vModelSelect, _ctx.filters[name]]
                              ])
                            : (name == 'severity')
                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 1,
                                  class: _normalizeClass(["severityStyles m-auto", _ctx.filters[name] == null ? 'inputboxstylingForSelect flex items-center justify-center' : 'stylingForInputboxstylingForSelect']),
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                }, [
                                  _createElementVNode("option", {
                                    value: _ctx.filters.name,
                                    selected: "",
                                    disabled: "",
                                    hidden: ""
                                  }, "Select", 8, _hoisted_15),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbSeverity, (value, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      class: "optionColors",
                                      key: index,
                                      value: value.value
                                    }, _toDisplayString(value.key), 9, _hoisted_16))
                                  }), 128))
                                ], 10, _hoisted_14)), [
                                  [_vModelSelect, _ctx.filters[name]]
                                ])
                              : (name == 'complianceStatus')
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 2,
                                    class: _normalizeClass(["resizeComplianceStatus", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                  }, [
                                    _createElementVNode("option", {
                                      value: _ctx.filters.name,
                                      selected: "",
                                      disabled: "",
                                      hidden: ""
                                    }, "Select", 8, _hoisted_18),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getComplianceStatusOptions(), (option) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        class: "optionColors",
                                        key: option.id,
                                        value: option.id
                                      }, _toDisplayString(option.value), 9, _hoisted_19))
                                    }), 128))
                                  ], 10, _hoisted_17)), [
                                    [_vModelSelect, _ctx.filters[name]]
                                  ])
                                : _createCommentVNode("", true),
                          (name=='Type')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 3,
                                class: _normalizeClass([_ctx.filters[name] == null ? 'inputboxstylingForSelect criticalitystyling' : 'stylingForInputboxstylingForSelect criticalitystyling', "widthForTypeSelect"]),
                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                              }, [
                                _createElementVNode("option", {
                                  value: _ctx.filters.name,
                                  selected: "",
                                  hidden: "",
                                  disabled: ""
                                }, "Select", 8, _hoisted_21),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectTypeOptions, (pair) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    class: "optionColors",
                                    key: pair,
                                    value: pair.id
                                  }, _toDisplayString(pair.value), 9, _hoisted_22))
                                }), 128))
                              ], 10, _hoisted_20)), [
                                [_vModelSelect, _ctx.filters[name]]
                              ])
                            : (name == 'statusCode')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _withDirectives(_createElementVNode("select", {
                                    class: _normalizeClass(["priorityStyles", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                  }, [
                                    _createElementVNode("option", {
                                      value: _ctx.filters.name,
                                      selected: "",
                                      disabled: "",
                                      hidden: ""
                                    }, "Select", 8, _hoisted_25),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (option) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        class: "optionColors",
                                        key: option.id,
                                        value: option.id
                                      }, _toDisplayString(option.label), 9, _hoisted_26))
                                    }), 128))
                                  ], 10, _hoisted_24), [
                                    [_vModelSelect, _ctx.filters[name]]
                                  ])
                                ]))
                              : (name == 'capastatusCode')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _withDirectives(_createElementVNode("select", {
                                      class: _normalizeClass(["priorityStyles", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                    }, [
                                      _createElementVNode("option", {
                                        value: _ctx.filters.name,
                                        selected: "",
                                        disabled: "",
                                        hidden: ""
                                      }, "Select", 8, _hoisted_29),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.capaStatuses, (option) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          class: "optionColors",
                                          key: option.id,
                                          value: option.id
                                        }, _toDisplayString(option.label), 9, _hoisted_30))
                                      }), 128))
                                    ], 10, _hoisted_28), [
                                      [_vModelSelect, _ctx.filters[name]]
                                    ])
                                  ]))
                                : (name == 'health')
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 6,
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event),
                                      class: _normalizeClass([_ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect', "widthforHealthSelect"])
                                    }, [
                                      _createElementVNode("option", {
                                        value: _ctx.filters.name,
                                        selected: "",
                                        hidden: "",
                                        disabled: ""
                                      }, "Select", 8, _hoisted_32),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCriticalityOptions(), (option) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          class: "optionColors",
                                          key: option.id,
                                          value: option.id
                                        }, _toDisplayString(option.value), 9, _hoisted_33))
                                      }), 128))
                                    ], 10, _hoisted_31)), [
                                      [_vModelSelect, _ctx.filters[name]]
                                    ])
                                  : (name == 'kpiHealth')
                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 7,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event),
                                        class: _normalizeClass([_ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect', "widthforStatusSelect"])
                                      }, [
                                        _createElementVNode("option", {
                                          value: _ctx.filters.name,
                                          selected: "",
                                          hidden: "",
                                          disabled: ""
                                        }, "Select", 8, _hoisted_35),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiHealthValues, (pair) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            class: "optionColors",
                                            key: pair.id,
                                            value: pair.id
                                          }, _toDisplayString(pair.value), 9, _hoisted_36))
                                        }), 128))
                                      ], 10, _hoisted_34)), [
                                        [_vModelSelect, _ctx.filters[name]]
                                      ])
                                    : (name == 'Status')
                                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                          key: 8,
                                          class: "inputboxstylingForSelect resize",
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                        }, [
                                          _createElementVNode("option", {
                                            value: _ctx.filters.name,
                                            selected: "",
                                            disabled: "",
                                            hidden: ""
                                          }, "Select", 8, _hoisted_38),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.status, (value, index) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: index,
                                              value: value
                                            }, _toDisplayString(value), 9, _hoisted_39))
                                          }), 128))
                                        ], 8, _hoisted_37)), [
                                          [_vModelSelect, _ctx.filters[name]]
                                        ])
                                      : (name == 'criticality')
                                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                            key: 9,
                                            class: _normalizeClass(["widthForCriticalitySelect", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                          }, [
                                            _createElementVNode("option", {
                                              value: _ctx.filters.name,
                                              selected: "",
                                              disabled: "",
                                              hidden: ""
                                            }, "Select", 8, _hoisted_41),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbProcessCriticality, (value) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                class: "optionColors",
                                                key: value.value,
                                                value: value.value
                                              }, _toDisplayString(value.key), 9, _hoisted_42))
                                            }), 128))
                                          ], 10, _hoisted_40)), [
                                            [_vModelSelect, _ctx.filters[name]]
                                          ])
                                        : (name == 'Target Time Period' || name == 'targetTimePeriod' || name == 'Reporting Frequency' || name == 'reportingFrequency')
                                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                              key: 10,
                                              class: "inputboxstylingForSelect resize",
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                            }, [
                                              _createElementVNode("option", {
                                                value: _ctx.filters.name,
                                                selected: "",
                                                hidden: "",
                                                disabled: ""
                                              }, "Select", 8, _hoisted_44),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlRecurringArray, (pair, index) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  key: index,
                                                  value: pair.id
                                                }, _toDisplayString(pair.label), 9, _hoisted_45))
                                              }), 128))
                                            ], 8, _hoisted_43)), [
                                              [_vModelSelect, _ctx.filters[name]]
                                            ])
                                          : (name == 'controlPriority')
                                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                key: 11,
                                                class: _normalizeClass(["widthForSelect", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                              }, [
                                                _createElementVNode("option", {
                                                  value: _ctx.filters.name,
                                                  selected: "",
                                                  disabled: "",
                                                  hidden: ""
                                                }, "Select", 8, _hoisted_47),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbPriority, (pair) => {
                                                  return (_openBlock(), _createElementBlock("option", {
                                                    class: "optionColors",
                                                    key: pair,
                                                    value: pair.value
                                                  }, _toDisplayString(pair.key), 9, _hoisted_48))
                                                }), 128))
                                              ], 10, _hoisted_46)), [
                                                [_vModelSelect, _ctx.filters[name]]
                                              ])
                                            : (name == 'type')
                                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                  key: 12,
                                                  class: _normalizeClass(["widthForSelect", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                }, [
                                                  _createElementVNode("option", {
                                                    value: _ctx.filters.name,
                                                    selected: "",
                                                    disabled: "",
                                                    hidden: ""
                                                  }, "Select", 8, _hoisted_50),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskType, (pair) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                      class: "optionColors",
                                                      key: pair,
                                                      value: pair.id
                                                    }, _toDisplayString(pair.value), 9, _hoisted_51))
                                                  }), 128))
                                                ], 10, _hoisted_49)), [
                                                  [_vModelSelect, _ctx.filters[name]]
                                                ])
                                              : (name == 'controlFrequency' || name == 'Frequency')
                                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                    key: 13,
                                                    class: _normalizeClass(["widthForSelect", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                    "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                  }, [
                                                    _createElementVNode("option", {
                                                      value: _ctx.filters.name,
                                                      selected: "",
                                                      disabled: "",
                                                      hidden: ""
                                                    }, "Select", 8, _hoisted_53),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbFrequency, (pair) => {
                                                      return (_openBlock(), _createElementBlock("option", {
                                                        class: "optionColors",
                                                        key: pair,
                                                        value: pair.value
                                                      }, _toDisplayString(pair.key), 9, _hoisted_54))
                                                    }), 128))
                                                  ], 10, _hoisted_52)), [
                                                    [_vModelSelect, _ctx.filters[name]]
                                                  ])
                                                : (name == 'tier')
                                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                      key: 14,
                                                      class: _normalizeClass(["widthForTierSelect", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                      "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                    }, [
                                                      _createElementVNode("option", {
                                                        value: _ctx.filters.name,
                                                        selected: "",
                                                        disabled: "",
                                                        hidden: ""
                                                      }, "Select", 8, _hoisted_56),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityValues, (pair) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          class: "optionColors",
                                                          key: pair,
                                                          value: pair.id
                                                        }, _toDisplayString(pair.value), 9, _hoisted_57))
                                                      }), 128))
                                                    ], 10, _hoisted_55)), [
                                                      [_vModelSelect, _ctx.filters[name]]
                                                    ])
                                                  : (name=='status')
                                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                        key: 15,
                                                        class: _normalizeClass([_ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect', "widthforStatusSelect"]),
                                                        "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                      }, [
                                                        _createElementVNode("option", {
                                                          value: _ctx.select,
                                                          selected: "",
                                                          hidden: "",
                                                          disabled: ""
                                                        }, "Select", 8, _hoisted_59),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeValues, (pair) => {
                                                          return (_openBlock(), _createElementBlock("option", {
                                                            class: "optionColors",
                                                            key: pair,
                                                            value: pair.id
                                                          }, _toDisplayString(pair.value), 9, _hoisted_60))
                                                        }), 128))
                                                      ], 10, _hoisted_58)), [
                                                        [_vModelSelect, _ctx.filters[name]]
                                                      ])
                                                    : (name == 'publicFacing')
                                                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                          key: 16,
                                                          "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event),
                                                          class: _normalizeClass([_ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect', "widthforStatusSelect"])
                                                        }, [
                                                          _createElementVNode("option", {
                                                            value: _ctx.filters.name,
                                                            selected: "",
                                                            hidden: "",
                                                            disabled: ""
                                                          }, "Select", 8, _hoisted_62),
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publicFacingOptions, (pair) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                              class: "optionColors",
                                                              key: pair,
                                                              value: pair.id
                                                            }, _toDisplayString(pair.value), 9, _hoisted_63))
                                                          }), 128))
                                                        ], 10, _hoisted_61)), [
                                                          [_vModelSelect, _ctx.filters[name]]
                                                        ])
                                                      : ( name == 'actionButtonAtCompliance' || name == 'actionButtonAtObjective' || name == 'actionButtonForKPIs' || name == 'compliancePeriod' || name == 'TotalNumberofControls'||name=='target (%)'||name=='Target'  || name == 'No. of Controls' || name == 'no.of controls' || name == 'weightage (%)' || name == 'frameWorks'|| name == 'no.of Kpis' || name == 'Weightage (%)' || name == 'Date of Target' || name == 'startDate' || name == 'dueDate' || name == 'completedDate' || name == 'createdAt' || name == 'createdOn'|| name=='endDate' || name=='Date of Target' || name=='KPIs' || name == 'No. of Controls' || name == 'kpiDelete' || name == 'deleteIcon'|| name=='status'|| name=='severity'|| name=='priority'||name=='complianceStatus'||name=='controlscount'||name=='publicFacing' || name=='kpiId')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_64))
                                                        : ( name == 'Id' )
                                                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                              key: 18,
                                                              type: "text",
                                                              class: "inputboxstylingForControlID",
                                                              placeholder: "Search",
                                                              "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                            }, null, 8, _hoisted_65)), [
                                                              [_vModelText, _ctx.filters[name]]
                                                            ])
                                                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                              key: 19,
                                                              type: "text",
                                                              placeholder: "Search",
                                                              class: "searchForInputBoxStyling",
                                                              "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                            }, null, 8, _hoisted_66)), [
                                                              [_vModelText, _ctx.filters[name]]
                                                            ])
                        ], 6))
                      }), 128)),
                      (_ctx.tabelActionBtn)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_67))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("table", {
              class: "table-fit-card",
              style: _normalizeStyle(_ctx.tableResizeStyle)
            }, [
              _createElementVNode("colgroup", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
                  return (_openBlock(), _createElementBlock("col", {
                    key: 'b-'+presentColumn,
                    style: _normalizeStyle(_ctx.columnStyle(presentColumn))
                  }, null, 4))
                }), 128))
              ]),
              (_ctx.loadData == true)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_69, [
                    _createElementVNode("tr", _hoisted_70, [
                      _createElementVNode("td", {
                        class: "relative h-5",
                        colspan: _ctx.columnNames.size
                      }, [
                        _createElementVNode("div", _hoisted_72, [
                          _createVNode(_component_dots_loader)
                        ])
                      ], 8, _hoisted_71)
                    ])
                  ]))
                : (_ctx.sortedData.length == 0 )
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_73, [
                      _createElementVNode("tr", _hoisted_74, [
                        _createElementVNode("td", {
                          class: "relative h-10",
                          colspan: _ctx.columnNames.size
                        }, _cache[1] || (_cache[1] = [
                          _createElementVNode("div", { class: "flex justify-center" }, [
                            _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                          ], -1)
                        ]), 8, _hoisted_75)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_76, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (row, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: row,
                          class: "cursor-pointer hoverEffectForCompleteRow"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: column,
                              onMouseout: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doFalse())),
                              onClick: ($event: any) => (_ctx.showBlockAction(row, index, column)),
                              class: _normalizeClass(["cursor-pointer relative", [_ctx.getColumnHeadWidth(column), column == 'priority'|| column == 'status'|| column=='tier'|| column=='controlFrequency'|| column=='kpiHealth' ? 'text-center' : '']]),
                              style: _normalizeStyle(_ctx.columnStyle(column))
                            }, [
                              ((column == 'Target Time Period' || column == 'targetTimePeriod' || column == 'Reporting Frequency' || column == 'reportingFrequency') && typeof row[column] === 'number')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                    _createElementVNode("div", null, _toDisplayString(_ctx.controlRecurringArray.find((l) => {
											return l.id == row[column];
										}).label), 1)
                                  ]))
                                : (column == 'Date of Target' || column == 'KPI\'s' || column == 'Created on' || column == 'frameWorks' || column == 'Target (%)' || column == 'Weightage (%)' || column == 'no.of Kpis' || column=='weightage (%)' || column=='TotalNumberofControls'||column=='target (%)'||column=='Target')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                      _createElementVNode("div", _hoisted_80, _toDisplayString(row[column]), 1)
                                    ]))
                                  : (column == 'startDate')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                        _createElementVNode("div", _hoisted_82, _toDisplayString(row[column]), 1)
                                      ]))
                                    : (column =='dueDate')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 3,
                                          class: _normalizeClass(["flex justify-center items-center w-20 rounded h-5", _ctx.shouldStyleDueDate(row) ? _ctx.colorForDueDate(row[column]) : ''])
                                        }, _toDisplayString(row[column]), 3))
                                      : (column == 'compliancePeriod'|| column=='projectOwner')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, _toDisplayString(row[column]), 1))
                                        : (column == 'deleteIcon'||column == 'kpiDelete')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                              _createElementVNode("div", _hoisted_85, [
                                                _createElementVNode("img", {
                                                  src: _imports_0,
                                                  class: "cursor-pointer",
                                                  onClick: ($event: any) => (_ctx.emitDeleteRowEvent(row,index))
                                                }, null, 8, _hoisted_86)
                                              ])
                                            ]))
                                          : (column == 'team')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                                _createElementVNode("div", _hoisted_88, [
                                                  _createElementVNode("div", {
                                                    onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'text'))
                                                  }, _toDisplayString(_ctx.getTeamName(row[column])), 41, _hoisted_89)
                                                ])
                                              ]))
                                            : (column == 'type')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(_ctx.getTaskType(row[column])), 1))
                                              : (column == 'controlFrequency' || column=='Frequency')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                                    _createElementVNode("div", _hoisted_92, [
                                                      _createElementVNode("div", {
                                                        onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'text'))
                                                      }, _toDisplayString(_ctx.getFrequency(row[column])), 41, _hoisted_93)
                                                    ])
                                                  ]))
                                                : (column == 'health')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                                      (row[column] == 'N/A'||row[column]==undefined||row[column]==null||row[column]==='')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_95, _cache[2] || (_cache[2] = [
                                                            _createElementVNode("div", null, "N/A", -1)
                                                          ])))
                                                        : (_openBlock(), _createElementBlock("div", {
                                                            key: 1,
                                                            class: _normalizeClass(["rounded-full w-5 h-5 mx-auto", _ctx.colorEffectivenessBg(row[column])?.color]),
                                                            onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'circleButton'))
                                                          }, null, 42, _hoisted_96))
                                                    ]))
                                                  : (column == 'kpiHealth')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                                        (row[column] == 'N/A'||row[column]==undefined)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_98, _cache[3] || (_cache[3] = [
                                                              _createElementVNode("div", null, "N/A", -1)
                                                            ])))
                                                          : (row[column] == 'Pass')
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 1,
                                                                class: "rounded-full w-5 h-5 bg-active mx-auto",
                                                                onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'circleButton'))
                                                              }, null, 40, _hoisted_99))
                                                            : (row[column] == 'No Instances')
                                                              ? (_openBlock(), _createElementBlock("div", {
                                                                  key: 2,
                                                                  class: "rounded-full w-5 h-5 bg-disabledgrey mx-auto",
                                                                  onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'circleButton'))
                                                                }, null, 40, _hoisted_100))
                                                              : (_openBlock(), _createElementBlock("div", {
                                                                  key: 3,
                                                                  class: "rounded-full w-5 h-5 bg-error mx-auto",
                                                                  onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'circleButton'))
                                                                }, null, 40, _hoisted_101))
                                                      ]))
                                                    : (column == 'tier')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                                          _createElementVNode("div", _hoisted_103, [
                                                            _createElementVNode("div", {
                                                              onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'text'))
                                                            }, _toDisplayString(_ctx.getTierName(row[column])), 41, _hoisted_104)
                                                          ])
                                                        ]))
                                                      : (column == 'entity')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                                            _createElementVNode("p", _hoisted_106, _toDisplayString(_ctx.getLocationName(row[column])), 1)
                                                          ]))
                                                        : (column == 'No. of Controls')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                                              _createElementVNode("a", null, _toDisplayString(row[column]), 1)
                                                            ]))
                                                          : (column == 'statusCode')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28", _ctx.bgColorForFindingStatus(row[column])])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(_ctx.textColorForFindingStatus(row[column]))
                                                                  }, _toDisplayString(_ctx.getStatusLabelFromColumn(row[column],column)), 3)
                                                                ], 2)
                                                              ]))
                                                            : (column == 'capastatusCode')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28", _ctx.bgColorForFindingStatus(row[column])])
                                                                  }, [
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(_ctx.textColorForFindingStatus(row[column]))
                                                                    }, _toDisplayString(_ctx.getStatusLabelFromColumn(row[column],column)), 3)
                                                                  ], 2)
                                                                ]))
                                                              : (column == 'status')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                                                    (row[column] == 1)
                                                                      ? (_openBlock(), _createElementBlock("div", {
                                                                          key: 0,
                                                                          class: "rounded-full w-5 h-5 bg-active mx-auto",
                                                                          onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'circleButton'))
                                                                        }, null, 40, _hoisted_111))
                                                                      : (_openBlock(), _createElementBlock("div", {
                                                                          key: 1,
                                                                          class: "rounded-full w-5 h-5 bg-error mx-auto",
                                                                          onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'circleButton'))
                                                                        }, null, 40, _hoisted_112)),
                                                                    (row[column] == true && _ctx.pop == true)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_113, _cache[4] || (_cache[4] = [
                                                                          _createElementVNode("img", {
                                                                            src: _imports_1,
                                                                            alt: "",
                                                                            class: "absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3"
                                                                          }, null, -1),
                                                                          _createElementVNode("span", { class: "text-black text-center text-xs" }, null, -1),
                                                                          _createTextVNode(" Active ")
                                                                        ])))
                                                                      : _createCommentVNode("", true),
                                                                    (row[column] == false && _ctx.pop == true)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_114, _cache[5] || (_cache[5] = [
                                                                          _createElementVNode("img", {
                                                                            src: _imports_1,
                                                                            alt: "",
                                                                            class: "absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3"
                                                                          }, null, -1),
                                                                          _createElementVNode("span", { class: "text-black text-center text-xs" }, null, -1),
                                                                          _createTextVNode(" Inactive ")
                                                                        ])))
                                                                      : _createCommentVNode("", true)
                                                                  ]))
                                                                : (column == 'KPIs')
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_115, _toDisplayString(row[column]), 1))
                                                                  : (column == 'controlscount')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_116, _toDisplayString(row[column]), 1))
                                                                    : (column=='Type')
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                                                          _createElementVNode("div", {
                                                                            class: "table-ellipsis",
                                                                            onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'text'))
                                                                          }, _toDisplayString(_ctx.getProjectType(row[column])), 41, _hoisted_118)
                                                                        ]))
                                                                      : (column=='kpiId')
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                                                            _createElementVNode("div", {
                                                                              class: "table-ellipsis",
                                                                              onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'text'))
                                                                            }, _toDisplayString(row[column]), 41, _hoisted_120)
                                                                          ]))
                                                                        : (column=='publicFacing')
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                                                              _createElementVNode("div", _hoisted_122, [
                                                                                _createElementVNode("p", {
                                                                                  class: "fullText",
                                                                                  onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'text'))
                                                                                }, _toDisplayString(_ctx.getpublicFacing(row[column])), 41, _hoisted_123)
                                                                              ])
                                                                            ]))
                                                                          : (column == 'no.of controls')
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                                                                _createElementVNode("a", null, _toDisplayString(row[column]), 1)
                                                                              ]))
                                                                            : (column == 'complianceStatus')
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                                                                  _createElementVNode("div", {
                                                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorComplianceBg(row[column])])
                                                                                  }, [
                                                                                    _createElementVNode("div", {
                                                                                      class: _normalizeClass(_ctx.colorComplianceText(row[column]))
                                                                                    }, _toDisplayString(_ctx.getStatusLabelFromColumn(row[column],column)), 3)
                                                                                  ], 2)
                                                                                ]))
                                                                              : (column == 'criticality')
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                                                                    _createElementVNode("div", {
                                                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5", _ctx.colorPriorityBg(row[column])])
                                                                                    }, [
                                                                                      _createElementVNode("div", {
                                                                                        class: _normalizeClass(["table-ellipsisForValue", _ctx.colorPriorityText(row[column])]),
                                                                                        style: {"white-space":"break-spaces"},
                                                                                        onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'label'))
                                                                                      }, _toDisplayString(_ctx.getStatusLabelFromColumn(row[column],column)), 43, _hoisted_127)
                                                                                    ], 2)
                                                                                  ]))
                                                                                : (column == 'severity')
                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                                                                      _createElementVNode("div", _hoisted_129, [
                                                                                        _createElementVNode("div", {
                                                                                          class: _normalizeClass(["flex items-center justify-center rounded-full w-5 h-5", _ctx.colorPropBg('border', row.severity)]),
                                                                                          onMousemove: ($event: any) => (_ctx.toolTip(_ctx.presentColumn, $event, index, row, 'circle'))
                                                                                        }, [
                                                                                          _createElementVNode("div", {
                                                                                            class: _normalizeClass(["severityCircle rounded-full", _ctx.colorPropBg('circle', row.severity)])
                                                                                          }, null, 2)
                                                                                        ], 42, _hoisted_130)
                                                                                      ])
                                                                                    ]))
                                                                                  : (column == 'controlPriority')
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                                                                        _createElementVNode("div", {
                                                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorLabelBg(row[column])])
                                                                                        }, [
                                                                                          _createElementVNode("div", {
                                                                                            class: _normalizeClass(_ctx.colorLabelText(row[column]))
                                                                                          }, _toDisplayString(_ctx.getProirityLabel(row[column])), 3)
                                                                                        ], 2)
                                                                                      ]))
                                                                                    : (column == 'findingCategory')
                                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_132, _toDisplayString(_ctx.getStatusLabelFromColumn(row[column],column)), 1))
                                                                                      : (column == 'priority' && typeof row[column] === 'number')
                                                                                        ? (_openBlock(), _createElementBlock("div", {
                                                                                            key: 28,
                                                                                            class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28", _ctx.colorPriorityBg(row[column])])
                                                                                          }, [
                                                                                            _createElementVNode("div", {
                                                                                              class: _normalizeClass(_ctx.colorPriorityText(row[column]))
                                                                                            }, [
                                                                                              (row[column])
                                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_133, _toDisplayString(_ctx.dbPriority.find((l) => {
												return l.value === row[column];
											}).key), 1))
                                                                                                : (_openBlock(), _createElementBlock("div", _hoisted_134, "-"))
                                                                                            ], 2)
                                                                                          ], 2))
                                                                                        : (column == 'Status')
                                                                                          ? (_openBlock(), _createElementBlock("div", {
                                                                                              key: 29,
                                                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28", _ctx.colorTaskStatusBg(row[column])])
                                                                                            }, [
                                                                                              _createElementVNode("div", {
                                                                                                class: _normalizeClass(_ctx.colorTaskStatusText(row[column]))
                                                                                              }, _toDisplayString(row[column]), 3)
                                                                                            ], 2))
                                                                                          : (column == 'actionButtonAtCompliance')
                                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                                                                                                _createVNode(_component_Button, {
                                                                                                  type: "button",
                                                                                                  icon: "pi pi-ellipsis-v",
                                                                                                  onClick: ($event: any) => (_ctx.actionButtonToggle($event, index)),
                                                                                                  style: {"background-color":"white","color":"black","border":"white"},
                                                                                                  class: "action-button"
                                                                                                }, null, 8, ["onClick"]),
                                                                                                _createVNode(_component_Menu, {
                                                                                                  ref_for: true,
                                                                                                  ref: 'menu' + index,
                                                                                                  model: _ctx.actionButtonAtComplianceItems(row),
                                                                                                  popup: true,
                                                                                                  class: "menuWidth"
                                                                                                }, null, 8, ["model"])
                                                                                              ]))
                                                                                            : (column == 'actionButtonForKPIs')
                                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                                                                                  _createElementVNode("fieldset", null, [
                                                                                                    _createVNode(_component_Button, {
                                                                                                      type: "button",
                                                                                                      icon: "pi pi-ellipsis-v",
                                                                                                      onClick: ($event: any) => (_ctx.actionButtonToggle($event, index)),
                                                                                                      style: {"background-color":"white","color":"black","border":"white"},
                                                                                                      class: "action-button"
                                                                                                    }, null, 8, ["onClick"]),
                                                                                                    _createVNode(_component_Menu, {
                                                                                                      ref_for: true,
                                                                                                      ref: 'menu' + index,
                                                                                                      model: _ctx.actionButtonForKPIsItems(row),
                                                                                                      popup: true,
                                                                                                      class: "menuWidth"
                                                                                                    }, null, 8, ["model"])
                                                                                                  ])
                                                                                                ]))
                                                                                              : (column == 'actionButtonAtObjective')
                                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                                                                                    _createElementVNode("fieldset", null, [
                                                                                                      _createVNode(_component_Button, {
                                                                                                        type: "button",
                                                                                                        icon: "pi pi-ellipsis-v",
                                                                                                        onClick: ($event: any) => (_ctx.actionButtonToggle($event, index)),
                                                                                                        style: {"background-color":"white","color":"black","border":"white"},
                                                                                                        class: "action-button"
                                                                                                      }, null, 8, ["onClick"]),
                                                                                                      _createVNode(_component_Menu, {
                                                                                                        ref_for: true,
                                                                                                        ref: 'menu' + index,
                                                                                                        model: _ctx.actionButtonAtObjectiveItems(row),
                                                                                                        popup: true,
                                                                                                        class: "menuWidth"
                                                                                                      }, null, 8, ["model"])
                                                                                                    ])
                                                                                                  ]))
                                                                                                : (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                                                                                    _createElementVNode("div", _hoisted_139, [
                                                                                                      _createElementVNode("p", {
                                                                                                        class: "fullText",
                                                                                                        onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'text'))
                                                                                                      }, _toDisplayString(row[column]), 41, _hoisted_140)
                                                                                                    ])
                                                                                                  ]))
                            ], 46, _hoisted_77))
                          }), 128)),
                          (_ctx.tabelActionBtn)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_141, [
                                _createElementVNode("div", _hoisted_142, [
                                  _createElementVNode("img", {
                                    src: _imports_2,
                                    onClick: ($event: any) => (_ctx.calculateDropdownPosition($event, index,'outerAction')),
                                    class: "h-5 w-5 cursor-pointer"
                                  }, null, 8, _hoisted_143)
                                ]),
                                (_ctx.showBlock && _ctx.showBlockindex === index)
                                  ? (_openBlock(), _createElementBlock("ul", {
                                      key: 0,
                                      class: _normalizeClass(["card shadow-sm z-30 absolute cursor-pointer", _ctx.isNearBottom(index)|| index == 1 ? 'dropdown-up1' : 'zIndexingForActionDropDown2']),
                                      style: _normalizeStyle([_ctx.isNearBottom(index) ? {} : {left: _ctx.dynamicLeftPosition + 'px',top: _ctx.dynamicTopPosition + 'px',display: _ctx.showDropDown ? 'block' : 'none'}, {"right":"0px","margin-right":"61px","position":"absolute"}])
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableRouteArr, (option, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          class: "cursor-pointer py-2 hover:bg-lightgrey h-7 w-24 flex items-center",
                                          key: index,
                                          onClick: ($event: any) => (_ctx.navigate(row, option))
                                        }, [
                                          _createElementVNode("div", _hoisted_145, [
                                            _cache[6] || (_cache[6] = _createElementVNode("img", {
                                              src: _imports_3,
                                              class: "h-4 w-4 mx-2.5"
                                            }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(option.value), 1)
                                          ])
                                        ], 8, _hoisted_144))
                                      }), 128))
                                    ], 6))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
            ], 4)
          ])
        ]),
        _createVNode(_component_pagination, {
          dynamicPagination: _ctx.dynamicPagination,
          onCurrentPageUpdate: _ctx.paginationUpdations,
          sortedData: _ctx.sortedData
        }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
      ])
    ], 2)
  ]))
}